import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint, Label } from '@progress/kendo-react-labels';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useLazyGetProjectQuery } from '../../redux/api/cache';

export default function AutocompleteProject(fieldRenderProps) {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    onChange,
    value,
  } = fieldRenderProps;
  const editorRef = React.useRef(null);
  const [data, setData] = React.useState([`,#${value}`]);
  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : '';
  const errorId = showValidationMessage ? `${id}_error` : '';
  const labelId = label ? `${id}_label` : '';
  const [getProject] = useLazyGetProjectQuery();

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <DropDownList
          defaultItem
          onChange={(e) => {
            onChange(e);
          }}
          onFilterChange={async (e) => {
            let res = await getProject({ camp_descr: e.filter.value }).unwrap();
            if (res.success)
              setData(
                res.data.map(
                  (item) => `${item.camp_descr}, #${item.camp_num}`
                )
              );
          }}
          data={data}
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          ref={editorRef}
          valid={valid}
          id={id}
          disabled={disabled}
          wrapperStyle={{ width: '20%', marginLeft: '18px' }}
          value={String(value)}
        />
      </div>
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
}

AutocompleteProject.propTypes = {
  disabled: PropTypes.any,
  hint: PropTypes.any,
  id: PropTypes.any,
  label: PropTypes.any,
  onChange: PropTypes.func,
  touched: PropTypes.any,
  valid: PropTypes.any,
  validationMessage: PropTypes.any,
  value: PropTypes.any,
  wrapperStyle: PropTypes.any,
};
